import React from "react";

interface InvoiceInfoSectionProps {
    dateOfDirectShipment: string;
    onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const InvoiceInfoSection: React.FC<InvoiceInfoSectionProps> = ({
    dateOfDirectShipment,
    onInputChange
}) => {
    return (
        <div>
            <label htmlFor="dateOfDirectShipment" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Date of Direct Shipment *
            </label>
            <input
                type="date"
                id="dateOfDirectShipment"
                name="dateOfDirectShipment"
                value={dateOfDirectShipment}
                onChange={onInputChange}
                required
                className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white text-sm"
            />
        </div>
    );
};
